import { FC, HTMLAttributes } from "react"
import { useTranslation } from "react-i18next"

import { EndDateError } from "hooks/useEarlyReturnEndDateValidation"
import Button from "components/Button/Button"
import { Flex } from "components/Flex"
import Status, { StatusType } from "components/Status/Status"
import reservationSidebars from "stores/reservationSidebars"
import { Guid } from "@/types"
import { ReservationSidebarTab } from "components/ReservationSidebar/ReservationSidebar"

interface IEarlyReturnEndDateErrorsProps {
    reservationId: Guid
    errors: EndDateError[]
    className?: HTMLAttributes<HTMLDivElement>['className']
}

const EarlyReturnEndDateErrors: FC<IEarlyReturnEndDateErrorsProps> = ({
    reservationId,
    errors,
    className,
}) => {
    const { t } = useTranslation()

    if (errors.length === 0) return null

    return (
        <Flex flow="column" gap="1.6rem" className={className}>
            {errors.map((err, idx) => (
                <Status type={StatusType.error} key={idx}>
                    {err === EndDateError.invoices &&
                        <>
                            <div className="mb-1">{t('earlyReturn.endDateErrorInvoices')}</div>
                            <Button
                                theme="link"
                                onClick={() => reservationSidebars.show({ reservationId, initTabIndex: ReservationSidebarTab.invoices })}
                                label={t('earlyReturn.showInvoices')}
                            />
                        </>
                    }
                    {err === EndDateError.assets &&
                        t('earlyReturn.endDateErrorAssets')
                    }
                    {err === EndDateError.system &&
                        t('message.systemError')
                    }
                </Status>
            ))}
        </Flex>
    )
}

export default EarlyReturnEndDateErrors
